import { useEffect, useLayoutEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Modal, ModalBody } from 'reactstrap'
import { getLocalStorageItem } from '../../../Helper/cookieHelper'
import { setNotification } from '../../../Redux/Reducers/notificationHandling'
import { request } from '../../../Redux/Sagas/requests/api'
import FieldsLayout from './fieldsLayout'
import { FaPlus } from 'react-icons/fa'
import { primary_color } from '../../../Helper/uiHelper'
import {
  _validateFormData,
  filterActiveEditUnits,
  getPublicCheckoutContactEmail,
  normalizeGetOldBookingList,
  remapUnitsToOpenYear,
  savePublicCheckoutContactEmail,
} from '../../../Helper/publicPageHelper'
import { EDIT_BOOKING_FOCUS_MESSAGE } from '../../PageSpecificComponents/Purchase/editPurchase'
import useMediaQuery from '../../../CustomHook/useMediaQuery'
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import CMSWidgetModal from '../../CMSWidget/cmsWidgetModal'
import CMSFormEdit from '../../CMSWidget/Form/cmsFormEdit'
import {  getDomainDetailsById, updateDomainDetailInRedux } from '../../../helper'
import Loader from 'react-loaders'
import '../../Form/Fields/roundedInput.scss'

const action_button = [
  {
    title: 'Cancel',
    component_call_action: {
      action: 'main_page',
    },
    outline: true,
    color: 'danger',
  },
  {
    title: 'Continue',
    component_call_action: {
      action: 'open_child_page',
      page: 'locker_payment',
    },
    color: 'info',
    icon: 'fa-solid fa-arrow-right',
  },
]

const changeNcontinueButton = {
  title: 'Change & Continue',
  component_call_action: {
    action: 'open_child_page',
    page: 'locker_payment',
  },
  color: 'info',
  icon: 'fa-solid fa-arrow-right',
}

const getButtonLabel = (label) => {
  if (label == null) return ''
  if (typeof label === 'string' || typeof label === 'number') return label
  if (typeof label === 'object') {
    return label?.title || label?.text || label?.label || label?.value || ''
  }
  return ''
}

const isValidEmailFormat = (value) => {
  const t = typeof value === 'string' ? value.trim() : ''
  if (!t) return false
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(t)
}

const AddForm = ({
  onSubmitForm,
  validationError,
  setValidationError,
  form,
  onValueChange,
  submittedFormData,
  formData,
  updateFormData,
  formIndex,
  onRemoveFormData,
  parentData,
  formsData,
  unitData,
  setUnitData,
  setFormData,
}) => {
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const isEditing = searchParams.get('edit_booking')
  // const [formValue, updateFormValue] = useState({
  //   category_id: '',
  //   item_date_time_id: '',
  //   location_id: '',
  // })
  // useEffect(() => {
  //   updateFormData(formValue, formIndex)
  // }, [formValue])

  const updateFormValue = (values) => {
    updateFormData(values, formIndex)
  }

  useEffect(() => {
    // updateFormValue(formData)
  }, [JSON.stringify(formData)])

  const content = [
    {
      layout: '[{"column":[{"col":"12"},{"col":"6"},{"col":"12"}]}]',
    },
  ]

  return (
    <div>
      <div className='d-flex justify-content-between align-items-center'>
        <div className='h4' style={{ fontWeight: '800', color: primary_color }}>
          Locker {formIndex + 1}
        </div>
        {!isEditing && (
          <Button
            outline
            onClick={() => onRemoveFormData(formIndex)}
            color='danger'
            className='rounded-pill subtitle1'
            style={{ paddingInline: '2rem' }}
            variant='outline-primary' // Change the variant to the desired color
          >
            Remove Student
          </Button>
        )}
      </div>
      <FieldsLayout
        validationError={validationError}
        setValidationError={setValidationError}
        form={form}
        formIndex={formIndex}
        content={content}
        formFieldValue={formData}
        setFormFieldValue={updateFormValue}
        parentData={parentData}
        allFormsData={formsData}
        unitData={unitData}
        setUnitData={setUnitData}
        setFormData={setFormData}
      />
    </div>
  )
}

const RenderSingleForm = () => {
  return <div>single form</div>
}

const RenderRepeatableForm = ({
  form,
  formsData,
  setFormData,
  parentData,
  data: widgetData,
  pageData,
  setActivePage,
  setParentData,
  onGoBackToHomePage,
  unitData,
  setUnitData,
  widget_uuid,
}) => {
  const dispatch = useDispatch()
  const [isReserving, setIsReserving] = useState(false)

  const isDesktop = useMediaQuery('(min-width:768px)')

  const sectionRef = useRef(null)
  const formSectionRefs = useRef([])
  const lastFocusedIndexRef = useRef(null)

  const editMode = useSelector((state) => state.CMS.editMode)
  const publicUser = useSelector((state) => state?.User?.publicUser)
  const isGuestPublicUser = !publicUser?.email

  const [modalPosition, setModalPosition] = useState()

  const handleSectionClick = () => {
    if (!editMode) return
    if (sectionRef.current) {
      const rect = sectionRef.current.getBoundingClientRect()
      setModalPosition({
        top: rect.height + 150,
        width: '60vw',
      })
    }
  }

  const [validationError, setValidationError] = useState(false)
  const [checkoutEmail, setCheckoutEmail] = useState('')
  const [checkoutEmailError, setCheckoutEmailError] = useState(false)
  const [parentDetails, setParentDetails] = useState()

  useLayoutEffect(() => {
    if (!isGuestPublicUser) return
    setCheckoutEmail((prev) => prev || getPublicCheckoutContactEmail() || '')
  }, [isGuestPublicUser])

  useEffect(() => {
    if (!isGuestPublicUser) return
    savePublicCheckoutContactEmail(checkoutEmail)
  }, [checkoutEmail, isGuestPublicUser])

  let storage_timer = getLocalStorageItem('timer') && JSON.parse(getLocalStorageItem('timer'))
  const location = useLocation()
  const history = useHistory()
  const searchParams = new URLSearchParams(location.search)
  const parent_id = searchParams.get('parent_id')
  const isEditing = searchParams.get('edit_booking')

  let current_storage_timer = storage_timer?.[parent_id]
  useEffect(() => {
    const fields = form?.component_call_fields?.map((item) => item?.field_id)
    if (parent_id) {
      if (getDomainDetailsById(parent_id)) {
        setParentDetails(getDomainDetailsById(parent_id))
      } else {
        request('retrieve-data-by-table', 'POST', {
          source_table: 'domains',
          row_id: parent_id,
        }).then((res) => {
          if (res?.data) {
            setParentDetails(res?.data?.data)
            updateDomainDetailInRedux(parent_id, res?.data?.data)
          }
        })
      }
    }

    if (!!searchParams.get('retrieve_booking')) {
      request('retrieve-reservation-session', 'POST', { parent_id: searchParams.get('parent_id') }).then((res) => {
        if (res?.data?.data && res?.data?.data?.units) {
          let items = JSON.parse(JSON.stringify(res?.data?.data.units))
          setFormData(items)
          setUnitData(items)
        }
      })
    } else if (!!searchParams.get('old_booking')) {
      const contactEmail =
        (publicUser?.email && String(publicUser.email).trim()) || getPublicCheckoutContactEmail().trim()
      if (!contactEmail) return

      request('get-old-booking', 'POST', {
        parent_id: searchParams.get('parent_id'),
        email: contactEmail,
      }).then((res) => {
        const bookings = normalizeGetOldBookingList(res?.data)
        const oldBooking = bookings.find((item) => item.booking_id == searchParams.get('booking_id'))
        if (oldBooking && oldBooking?.units) {
          let items = JSON.parse(JSON.stringify(oldBooking?.units))
          const itemsToUpdate = items?.map((item) => {
            let obj = { ...item }
            obj['item_id'] = null
            obj['item_id_label'] = null
            obj['questions'] = item?.questions
            return obj
          })
          remapUnitsToOpenYear(itemsToUpdate, {
            domainId: searchParams.get('parent_id') && parseInt(searchParams.get('parent_id'), 10),
          }).then((mapped) => {
            setFormData(mapped)
            setUnitData(mapped)
          })
          return
        }
      })
    } else if (!!searchParams.get('edit_booking')) {
      const isAdminEdit = searchParams.get('is_admin') === 'true'
      const showOffDisplay = isAdminEdit || searchParams.get('show_off_display') === 'true'
      const prefillYearId = searchParams.get('item_date_time_id')
      request('get-booking-by-payment-id', 'POST', {
        payment_id: searchParams.get('payment_id') && parseInt(searchParams.get('payment_id')),
        show_off_display: showOffDisplay,
      }).then((res) => {
        if (res?.data && res?.data?.units) {
          let items = filterActiveEditUnits(JSON.parse(JSON.stringify(res?.data?.units)))
          // Apply Move → Edit handoff (year / block / locker) when present.
          try {
            const raw = sessionStorage.getItem('edit_move_context')
            const ctx = raw ? JSON.parse(raw) : null
            if (ctx && String(ctx.payment_id) === String(searchParams.get('payment_id'))) {
              items = items.map((item, index) => {
                if (index !== 0) return item
                return {
                  ...item,
                  item_date_time_id: ctx.item_date_time_id || item.item_date_time_id,
                  item_date_time_id_label: ctx.item_date_time_id_label || item.item_date_time_id_label,
                  location_id: ctx.location_id || item.location_id,
                  location_id_label: ctx.location_id_label || item.location_id_label,
                  category_id: ctx.category_id || item.category_id,
                  category_id_label: ctx.category_id_label || item.category_id_label,
                  item_id: ctx.item_id || null,
                  item_id_label: ctx.item_id_label || null,
                  total_cost: ctx.total_cost || item.total_cost,
                }
              })
              setFormData(items)
              setUnitData(items)
              return
            }
          } catch (e) {
            // ignore bad session context
          }
          if (prefillYearId) {
            const yearId = parseInt(prefillYearId, 10)
            // Edit booking already has the correct year — remapping clears locker labels and
            // wipes the sticky header via focus postMessage. Only remap when changing year.
            const alreadyOnYear = items.every(
              (unit) => !unit?.item_date_time_id || Number(unit.item_date_time_id) === yearId
            )
            if (alreadyOnYear) {
              setFormData(items)
              setUnitData(items)
              return
            }
            remapUnitsToOpenYear(items, {
              domainId: searchParams.get('parent_id') && parseInt(searchParams.get('parent_id'), 10),
              itemDateTimeId: yearId,
            }).then((mapped) => {
              setFormData(mapped)
              setUnitData(mapped)
            })
            return
          }
          setFormData(items)
          setUnitData(items)
        }
      })
    } else {
      if (!current_storage_timer?.session_uuid) return
      request('get-unit', 'POST', { uuid: current_storage_timer?.session_uuid, fields }).then((res) => {
        if (res.status === 200 || res?.status === 202) {
          if (res?.data?.unitData?.length > 0) {
            setFormData(res?.data?.unitData)
            setUnitData(res?.data?.unitData)
          }
        }
      })
    }
  }, [parent_id, publicUser?.email])

  useEffect(() => {
    if (!isEditing || !formsData?.length) return

    const postFocus = (index, force = false) => {
      const data = formsData[index]
      const saved = unitData?.[index] || {}
      if (!data || typeof window === 'undefined' || !window.parent || window.parent === window) return
      if (!force && lastFocusedIndexRef.current === index) return
      const payload = {
        type: EDIT_BOOKING_FOCUS_MESSAGE,
        index,
        item_date_time_id_label: data.item_date_time_id_label || saved.item_date_time_id_label || '',
        category_id_label: data.category_id_label || saved.category_id_label || '',
        location_id_label: data.location_id_label || saved.location_id_label || '',
        item_id_label: data.item_id_label || saved.item_id_label || '',
      }
      if (
        !payload.item_date_time_id_label &&
        !payload.category_id_label &&
        !payload.location_id_label &&
        !payload.item_id_label
      ) {
        return
      }
      lastFocusedIndexRef.current = index
      window.parent.postMessage(payload, window.location.origin)
    }

    // Seed parent with first locker when sections mount / change.
    postFocus(0, lastFocusedIndexRef.current == null)

    const ratios = new Map()
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const index = Number(entry.target.getAttribute('data-edit-form-index'))
          if (Number.isNaN(index)) return
          ratios.set(index, entry.isIntersecting ? entry.intersectionRatio : 0)
        })
        let bestIndex = 0
        let bestRatio = -1
        ratios.forEach((ratio, index) => {
          if (ratio > bestRatio) {
            bestRatio = ratio
            bestIndex = index
          }
        })
        if (bestRatio > 0) postFocus(bestIndex)
      },
      { root: null, threshold: [0.15, 0.35, 0.55, 0.75] }
    )

    formSectionRefs.current.forEach((el) => {
      if (el) observer.observe(el)
    })

    return () => observer.disconnect()
    // Re-bind when locker sections are added/removed, not on every field edit.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEditing, formsData?.length, formsData?.map((d) => d?.uuid ?? '').join('|'), unitData?.length])

  const updateFormData = (data, index) => {
    setFormData((prevFormsData) => {
      return prevFormsData.map((item, i) => {
        if (index === i) {
          return data
        } else {
          return item
        }
      })
    })
  }

  const onAddNewForm = () => {
    const newFormsData = [...formsData]
    newFormsData?.push({
      category_id: '',
      item_date_time_id: '',
      location_id: '',
      isNew: true,
    })
    setFormData(newFormsData)
  }

  const onRemoveFormData = (index) => {
    const newFormsData = []
    formsData?.map((item, i) => {
      if (index !== i) {
        newFormsData?.push(item)
      }
    })
    setFormData(newFormsData)
  }
  if (formsData && formsData.length) {
    const items = JSON.parse(JSON.stringify(formsData))
    items.forEach((e) => delete e['uuid'])
  }

  const onClickActionButton = (e, button) => {
    e.preventDefault()
    const type = button?.component_call_action?.action

    if (type === 'open_child_page' && !_validateFormData(formsData)) return setValidationError(true)
    let storage_timer = getLocalStorageItem('timer') && JSON.parse(getLocalStorageItem('timer'))
    let current_storage_timer = storage_timer?.[parentData?.id]
    switch (type) {
      case 'open_child_page':
        if (isGuestPublicUser) {
          const trimmedGuestEmail = checkoutEmail.trim()
          if (!trimmedGuestEmail || !isValidEmailFormat(trimmedGuestEmail)) {
            setCheckoutEmailError(true)
            dispatch(
              setNotification({
                type: 'error',
                message: !trimmedGuestEmail ? 'Please enter your email address.' : 'Please enter a valid email address.',
              })
            )
            return
          }
          setCheckoutEmailError(false)
        }
        const new_page = pageData?.child_pages?.find((item) => item?.name === button?.component_call_action?.page)
        const item_ids = []
        formsData?.forEach((data) => {
          if (!item_ids?.includes(data?.item_id)) {
            item_ids?.push(data?.item_id)
          }
        })

        if (item_ids?.length === 0) {
          dispatch(setNotification({ type: 'error', message: 'Please add atleast one student!' }))
          return
        }
        if (item_ids?.length !== formsData?.length) {
          dispatch(setNotification({ type: 'error', message: 'Please select unique locker!' }))
          return
        }
        let items = JSON.parse(JSON.stringify(formsData))
        if (formsData && formsData.length) {
          items = formsData.map((e) => {
            const { email: _rowEmailOmit, ...unit } = e
            if (unit && unit.questions && unit.questions.length) {
              const object = {}
              unit?.questions?.map((q) => (object[q.uuid] = q.answer))
              return {
                ...unit,
                questions: object,
              }
            } else return unit
          })
        }
        setIsReserving(true)
        request('reserve-item-booking', 'POST', {
          items,
          email: (publicUser?.email && String(publicUser.email).trim()) || checkoutEmail.trim(),
          session_key: current_storage_timer?.session_id,
          // Help API ignore our own restored hold after refresh.
          reservation_id: formsData?.[0]?.booking_reservation_id || formsData?.[0]?.reservation_id || undefined,
          domain_id: searchParams.get('parent_id'),
          payment_id: searchParams.get('payment_id') && parseInt(searchParams.get('payment_id')),
        }).then((res) => {
          setIsReserving(false)
          if (res.status === 200 || res.status === 202) {
            if (new_page) {
              // setActivePage(new_page)
              const searchParams = new URLSearchParams(location.search)
              searchParams.set('page_id', new_page?.uuid)

              history.push(`?${searchParams.toString()}`)
            }
          } else {
            dispatch(setNotification({ type: 'error', message: res?.data?.message }))
          }
        })

        return
      default:
        // setActivePage(pageData)
        // setParentData()
        onGoBackToHomePage()
    }
  }

  // const _retrievePrevBooking = () => {
  //   request('get-retrieve-booking', 'POST', { uuid: retrieve_uuid }).then((res) => {
  //     if (res?.data && res?.data.bookingReservation && res?.data.bookingReservation.units) {
  //       const items = JSON.parse(JSON.stringify(res?.data.bookingReservation.units))
  //       if (res?.data.bookingReservation.units.length) {
  //         items.forEach((e) => delete e['uuid'])
  //       }

  //       setFormData(items)
  //       setUnitData(items)
  //     }
  //   })
  // }

  const onCloseModal = () => {
    let element = sectionRef?.current
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'start' })
    }
    setModalPosition(null)
  }

  return (
    <div className='col-md-10 ml-auto mr-auto mb-5'>
      {parentDetails && (
        <div className={`mb-3 ${isDesktop ? '' : 'mt-5'}`}>
          <div className={`d-flex align-items-center `}>
            <div>
              {parentDetails?.logo && (
                <img
                  src={process.env.REACT_APP_STORAGE + parentDetails?.logo}
                  width='60'
                  height='60'
                  className='me-3'
                  style={{ borderRadius: '50%', objectFit: 'cover', border: '1px solid #495057' }}
                />
              )}
            </div>
            <div style={{ flex: 1 }} className='ml-4'>
              <div className='font-weight-bold body1' style={{ color: '#495057' }}>
                {parentDetails?.domain_name}
              </div>
            </div>
          </div>
        </div>
      )}
      <div className='my-4'>
        <hr></hr>
      </div>
      <form>
        {isGuestPublicUser && (
          <div className='mb-4'>
            <div className='body2' style={{ color: primary_color, marginBlock: '2rem 0.65rem' }}>
              Email <span className='text-danger'>*</span>
            </div>
            <div
              className='rounded-input-container d-flex align-items-center justify-content-center'
              style={{
                ...(checkoutEmailError ? { border: '1px solid red' } : {}),
                maxWidth: '28rem',
              }}>
              <input
                id='public-checkout-contact-email'
                type='email'
                name='email'
                autoComplete='email'
                placeholder='Email'
                className={checkoutEmailError ? 'red-placeholder rounded-input' : 'rounded-input'}
                value={checkoutEmail}
                onChange={(e) => {
                  setCheckoutEmail(e.target.value)
                  if (checkoutEmailError) setCheckoutEmailError(false)
                }}
                required
              />
            </div>
            {checkoutEmailError && (
              <div className='text-danger subtitle1 mt-1'>
                {!checkoutEmail.trim() ? 'This field is required.' : 'Please enter a valid email address.'}
              </div>
            )}
          </div>
        )}
        {formsData?.map((data, index) => {
          // Stable key: must not include item_id or other fields that change when the user picks a
          // different locker, or React remounts the whole form and resets dropdowns / local state.
          const formRowKey = data?.uuid != null && data?.uuid !== '' ? String(data.uuid) : `repeatable-student-${index}`
          return (
            <div
              key={formRowKey}
              data-edit-form-index={index}
              className={`mt-1 ml-auto mr-auto position-relative ${modalPosition && 'active-cms-edit'}`}
              onClick={handleSectionClick}
              ref={(el) => {
                formSectionRefs.current[index] = el
                if (index === 0) sectionRef.current = el
              }}>
              <AddForm
                formData={data}
                formIndex={index}
                validationError={validationError}
                setValidationError={setValidationError}
                updateFormData={updateFormData}
                form={form}
                onRemoveFormData={onRemoveFormData}
                parentData={parentData}
                formsData={formsData}
                unitData={unitData}
                setUnitData={setUnitData}
                setFormData={setFormData}
              />
              {modalPosition && (
                <CMSWidgetModal sx={{ ...modalPosition }} toggleModal={() => onCloseModal()}>
                  <CMSFormEdit
                    data={widgetData}
                    toggleModal={() => {
                      onCloseModal()
                    }}
                    widget_uuid={widget_uuid}
                  />
                </CMSWidgetModal>
              )}
              <div style={{ margin: '2rem 10%', width: '80%', borderBottom: index < formsData.length - 1 ? '1px solid' : '' }}></div>
            </div>
          )
        })}
        <div className='d-flex'>
          <Button className='btn rounded-pill  mt-3 mb-3' style={{ background: primary_color, paddingInline: '3rem' }} onClick={() => onAddNewForm()}>
            <span className='d-flex align-items-center subtitle1'>
              <FaPlus className='mr-1' /> ADD NEW STUDENT
            </span>
          </Button>
          {isEditing && (
            <Button
              className='ml-2 btn rounded-pill mt-3 mb-3 subtitle1'
              style={{
                background: primary_color,
                paddingInline: '3rem',
              }}
              type={changeNcontinueButton?.component_call_action?.action === 'open_child_page' ? 'submit' : ''}
              onClick={(e) => {
                onClickActionButton(e, changeNcontinueButton)
              }}>
              {getButtonLabel(changeNcontinueButton?.title)} {changeNcontinueButton?.icon && <i className={changeNcontinueButton?.icon}></i>}
            </Button>
          )}
        </div>

        <div className={`mt-4 d-flex flex-wrap ${isDesktop ? '' : 'mb-4'}`}>
          {!isEditing &&
            action_button?.map((button, index) => {
              if (button?.outline) {
                return (
                  <Button
                    key={button?.title || button?.component_call_action?.action || index}
                    color={button?.color}
                    outline={button?.outline}
                    className='mr-2 btn rounded-pill subtitle1 mb-3'
                    style={{
                      paddingInline: '6rem',
                      display: 'flex',
                      gap: '0.5rem',
                      alignItems: 'center',
                      // padding: isDesktop ? '0.7rem 5.5rem' : '0.6rem 3rem',
                    }}
                    type={button?.component_call_action?.action === 'open_child_page' ? 'submit' : ''}
                    onClick={(e) => {
                      onClickActionButton(e, button)
                    }}>
                    {getButtonLabel(button?.title)} {button?.icon && <i className={button?.icon}></i>}
                  </Button>
                )
              } else {
                return (
                  <Button
                    key={button?.title || button?.component_call_action?.action || index}
                    color={button?.color}
                    outline={button?.outline}
                    disabled={formsData?.length == 0}
                    className='mr-2 btn rounded-pill subtitle1  mb-3'
                    style={{
                      paddingInline: '5rem',
                      display: 'flex',
                      gap: '0.5rem',
                      alignItems: 'center',
                      backgroundColor: primary_color,
                      // padding: isDesktop ? '0.7rem 4.5rem' : '0.6rem 3rem',
                      borderColor: primary_color,
                      borderRadius: '20px',
                    }}
                    type={button?.component_call_action?.action === 'open_child_page' ? 'submit' : ''}
                    onClick={(e) => {
                      onClickActionButton(e, button)
                    }}>
                    {getButtonLabel(button?.title)} {button?.icon && <i className={button?.icon}></i>}
                  </Button>
                )
              }
            })}
        </div>
      </form>
      <Modal isOpen={isReserving} centered={true} toggle={() => {}} style={{ width: '30rem', boxShadow: 'none', maxWidth: '95vw' }}>
        <ModalBody>
          <div className='d-flex justify-content-center' style={{ height: '5rem', marginTop: '3rem' }}>
            <Loader type='ball-triangle-path' color={primary_color} />
          </div>

          <div className='text-center body2' style={{ color: primary_color }}>
            Please hold on while we booking locker for you...
          </div>
        </ModalBody>
      </Modal>
    </div>
  )
}

const PublicForm = ({
  form,
  parentData,
  data,
  pageData,
  setActivePage,
  setParentData,
  setSearchData,
  setFilterData,
  onGoBackToHomePage,
  unitData,
  setUnitData,
  formsData,
  setFormData,
  widget_uuid,
}) => {
  return (
    <>
      {form?.repeatable_form ? (
        <RenderRepeatableForm
          form={form}
          parentData={parentData}
          data={data}
          pageData={pageData}
          setActivePage={setActivePage}
          setParentData={setParentData}
          setSearchData={setSearchData}
          setFilterData={setFilterData}
          onGoBackToHomePage={onGoBackToHomePage}
          unitData={unitData}
          setUnitData={setUnitData}
          formsData={formsData}
          setFormData={setFormData}
          widget_uuid={widget_uuid}
        />
      ) : (
        <RenderSingleForm />
      )}
    </>
  )
}

export default PublicForm
